import styled from "@emotion/styled";

export const AboutCardContainer = styled.div`
    width: 80%;
    text-align: center;
    // padding:0 0 20px 0;
    margin: auto;
`;
export const AboutHeading = styled.div`
    font-weight:600;
    font-size:30px;
    color: rgb(23, 59, 94);
    margin-bottom: 0.9rem;
`;
export const AboutDetails = styled.div`
    font-weight:400;
    font-size: 18px;
    line-height: 36px;
`;
export const ButtonContainer = styled.div`
  margin-top: 1rem;
  max-width: 100%;
  display: flex;
  justify-content: center;
  gap: 0.75rem;
`;
